exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-error-table{margin-bottom:20px}.ele-import-error-cell{color:#fff;background:#f56c6c!important}.ele-import-error-cell:hover{background-color:#f56c6c!important;background:#f56c6c!important}", ""]);

// exports
